import React, { useEffect, useState } from "react";
import SelectField from "../../../../Components/SelectField";
import { allEmployeeURL } from "../../../../Library/URLs";
import { v4 as uuid } from "uuid";
import axios from "axios";
import { useSelector } from "react-redux";
import { BsTrash } from "react-icons/bs";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import { CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 32,
  height: 18,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 14,
    height: 14,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const PayrollApprove = ({
  assignedList,
  setAssignedList,
  enabled,
  setEnabled,
  updatePaySettings,
  paySetLoading,
}) => {
  const User = useSelector((state) => state.payroll.User);
  const { companyid } = useParams();
  const unique_id = uuid();
  const [allEmployees, setAllEmployees] = useState([]);

  useEffect(() => {
    fetch();
    // eslint-disable-next-line
  }, []);

  const fetch = async () => {
    // console.log('all employee API is call')
    const raw = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allEmployeeURL, raw)
      .then((res) => {
        if (res.data.success === true) {
          // setAllEmployees(res.data.data);
          const itemres = res.data.data?.map((item) => {
            return {
              label: `${item?.first_name} ${item?.middle_name} ${item?.last_name}`,
              value: item?.id,
            };
          });
          setAllEmployees(itemres);
        }

        // console.log('length',res.data.employees.length)
      })
      .catch((err) => {
        // console.log('error'+err.message)
      });
  };

  const assignFirstLevel = (value) => {
    let assignListCopy = [...assignedList];
    if (assignListCopy?.length > 0) {
      assignListCopy[0] = {
        level: "1",
        employee_id: value,
      };
    } else {
      assignListCopy.push({ level: "1", employee_id: value });
    }
    setAssignedList(assignListCopy);
  };

  const assignSecondLevel = (value) => {
    let assignListCopy = [...assignedList];
    if (assignListCopy?.length > 1) {
      assignListCopy[1] = {
        level: "2",
        employee_id: value,
      };
    } else {
      assignListCopy.push({ level: "2", employee_id: value });
    }
    setAssignedList(assignListCopy);
  };

  const assignThirdLevel = (value) => {
    let assignListCopy = [...assignedList];
    if (assignListCopy?.length > 2) {
      assignListCopy[2] = {
        level: "3",
        employee_id: value,
      };
    } else {
      assignListCopy.push({ level: "3", employee_id: value });
    }
    setAssignedList(assignListCopy);
  };

  const assignFourthLevel = (value) => {
    let assignListCopy = [...assignedList];
    if (assignListCopy?.length > 3) {
      assignListCopy[3] = {
        level: "4",
        employee_id: value,
      };
    } else {
      assignListCopy.push({ level: "4", employee_id: value });
    }
    setAssignedList(assignListCopy);
  };

  const assignFifthLevel = (value) => {
    let assignListCopy = [...assignedList];
    if (assignListCopy?.length > 1) {
      assignListCopy[1] = {
        level: "5",
        employee_id: value,
      };
    } else {
      assignListCopy.push({ level: "5", employee_id: value });
    }
    setAssignedList(assignListCopy);
  };

  const addApprover = () => {
    let assignedLength = assignedList?.length;
    let assignedListCopy = [...assignedList];
    if (assignedLength === 0) {
      assignedListCopy.push({
        level: "1",
        employee_id: "",
      });
    } else if (assignedLength === 1) {
      assignedListCopy.push({
        level: "2",
        employee_id: "",
      });
    } else if (assignedLength === 2) {
      assignedListCopy.push({
        level: "3",
        employee_id: "",
      });
    } else if (assignedLength === 3) {
      assignedListCopy.push({
        level: "4",
        employee_id: "",
      });
    } else if (assignedLength === 4) {
      assignedListCopy.push({
        level: "5",
        employee_id: "",
      });
    }
    setAssignedList(assignedListCopy);
  };

  const removeApprover = (id) => {
    let assignedListCopy = [...assignedList];
    assignedListCopy.pop();
    // assignedListCopy?.splice(id, 1);
    setAssignedList(assignedListCopy);
  };

  const handleChange = (id, value) => {
    if (id === 0) {
      assignFirstLevel(value);
    } else if (id === 1) {
      assignSecondLevel(value);
    } else if (id === 2) {
      assignThirdLevel(value);
    } else if (id === 3) {
      assignFourthLevel(value);
    } else if (id === 4) {
      assignFifthLevel(value);
    }
  };

  const handleEnable = () => {
    setEnabled(!enabled);
    if (assignedList?.length < 1) {
      setAssignedList([
        {
          level: "1",
          employee_id: "",
        },
      ]);
    }
  };
  return (
    <div>
      <div className="">
        <span style={{ display: "flex", justifyContent: "space-between" }}>
          <p style={{ marginBottom: "1rem" }}>Payroll Approval</p>
          <div>
            <FormControlLabel
              control={
                <IOSSwitch
                  sx={{ m: 1 }}
                  checked={enabled}
                  onChange={handleEnable}
                />
              }
              label="Enable"
            />
          </div>
        </span>
        <small>
          Payroll approvers are employees within your company that are
          responsible for reviewing & approving every payroll in your
          organisation before it is processsed.
        </small>
      </div>
      {enabled &&
        assignedList?.map((item, id) => (
          <div className="Pay_Row_Wrap" key={id}>
            <label htmlFor="">Level {id + 1} approver</label>
            <span className="Payroll_approver">
              <SelectField
                name="foundational_obj"
                onChange={(e) => handleChange(id, e.value)}
                options={allEmployees}
                value={allEmployees?.find(
                  (employee) => employee?.value === item?.employee_id
                )}
              />
            </span>
          </div>
        ))}
      {assignedList?.length < 5 && assignedList?.length > 0 && enabled && (
        <button onClick={addApprover} className="add_approve">
          Add Another Approver ({5 - assignedList?.length} left)
        </button>
      )}
      <div className="Payroll_Btn_contain">
        <button className="Payroll_app_edit" onClick={updatePaySettings}>
          {paySetLoading === false ? (
            "Update"
          ) : (
            <CircularProgress color="inherit" size={14} />
          )}
        </button>
        <button
          onClick={() => removeApprover()}
          disabled={!enabled}
          className="Btn_remove_payroll"
        >
          Remove
        </button>
      </div>
    </div>
  );
};

export default PayrollApprove;
